import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";
import * as types from "./Types";

export const getMembers = (type) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, { type });
    return Api.get(`/admin/members?${params}`);
  };
};
